<template>
    <div class="department-search" style="min-height:72px">
        <input id="departmentSearchInput" class="department-search__input"
            :arial-label="dictionary.AccessibilityGetByAddressSearch" type="text"
            :placeholder="dictionary.DepartmentSearchPlaceholder" :value="inputValue" />
        <button type="button" v-if="showLocationButton" v-on:click="getLocation" class="department-search__location"
            :aria-label="dictionary.AccessibilityGetByLocation">{{ dictionary.DepartmentSearchGetByLocation }}</button>

        <Dialog class="department-search__dialog" v-model:visible="showErrorDialog" :dismissable-mask="true"
            :show-header="false" :modal="true" :close-on-escape="true" :draggable="false">
            <div class="department-search__dialog-wrap">

                <p class="department-search__dialog-headline">{{dictionary.DepartmentSearchErrorDialogHeadline}}</p>
                <p v-html="dictionary.DepartmentSearchErrorDialogText"></p>
                <Button :label="dictionary.DepartmentSearchErrorButtonLabel" class="p-button-rounded" @click="showErrorDialog = false"></Button>
            </div>
        </Dialog>
    </div>
</template>

<script>
const locationHelpers = require('./locationHelpers.js');
const departmentsControllerUrl = "/lagerhoteller";

import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
export default {
    name: "locationSearch",
    props: ["useAPI", "showLocationButton"],
    components: {
        Dialog,
        Button
    },
    data() {
        return {
            isSearching: false,
            inputValue: "",
            showErrorDialog: false,
            dictionary: {}
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetLocationSearchDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        const vm = this;
        const inputField = document.getElementById('departmentSearchInput');
        (function pacSelectFirst(input) {
            if (input == null) return;
            // store the original event binding function
            var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

            function addEventListenerWrapper(type, listener) {
                // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
                // and then trigger the original listener.
                if (type == "keydown") {
                    var orig_listener = listener;
                    listener = function (event) {
                        var suggestion_selected = $(".pac-item-selected").length > 0;
                        if (event.which == 13 && !suggestion_selected) {
                            var simulated_downarrow = $.Event("keydown", {
                                keyCode: 40,
                                which: 40
                            });
                            orig_listener.apply(input, [simulated_downarrow]);
                        }

                        orig_listener.apply(input, [event]);
                    };
                }

                _addEventListener.apply(input, [type, listener]);
            }

            input.addEventListener = addEventListenerWrapper;
            input.attachEvent = addEventListenerWrapper;

            var autocomplete = null;
            var iterations = 0;
            var loadMapsTimer = setInterval(() => {
                if (typeof googleMapsLoaded !== 'undefined' && googleMapsLoaded == true) {
                    clearInterval(loadMapsTimer);
                    autocomplete = new google.maps.places.Autocomplete(input);

                    autocomplete.setTypes(['(regions)'])

                    autocomplete.setFields(
                        ['address_component', 'geometry']);

                    autocomplete.setComponentRestrictions(
                        { 'country': ['dk'] });


                    autocomplete.addListener('place_changed', function () {


                        let place = autocomplete.getPlace();
                        if (!place.geometry) {
                            // User entered the name of a Place that was not suggested and
                            // pressed the Enter key, or the Place Details request failed.
                            vm.showErrorDialog = true;

                            console.log("No details available for input: '" + place.name + "'");
                            return;
                        }

                        let latitude = place.geometry.location.lat();
                        let longitude = place.geometry.location.lng();
                        let city = locationHelpers.getCityNameFromAddressComponents(place.address_components);
                        vm.submitSearch(latitude, longitude, city);
                    });
                } else {
                    iterations++;
                }

                //Lets try for 10 seconds
                if (iterations === 100) {
                    clearInterval(loadMapsTimer);
                }

            }, 50);
        })(inputField);


        const urlParams = new URLSearchParams(window.location.search);
        const getByLocationParam = urlParams.get('getByLocation');
        if (getByLocationParam) {
            this.getLocation();
        }
    },
    methods: {
        getLocation() {
            const vm = this;
            if (navigator.geolocation) {
                vm.isSearching = true;

                navigator.geolocation.getCurrentPosition(function (location) {
                    let latitude = location.coords.latitude;
                    let longitude = location.coords.longitude;
                    locationHelpers.getCityNameFromLocation(latitude,
                        longitude,
                        function (cityName) {
                            vm.submitSearch(latitude, longitude, cityName);
                            vm.inputValue = cityName;
                            vm.isSearching = false;
                        });
                });
            } else {
                vm.isSearching = false;
                alert("Geolocation is not supported by this browser.");
            }
        },
        submitSearch(latitude, longitude, city) {
            if (!this.useAPI) {
                window.location.href = departmentsControllerUrl + "?lat=" + latitude + "&lng=" + longitude + "&city=" + city;
            } else {
                this.$emit('locationSearchApiSubmit', { latitude: latitude, longitude: longitude, city: city });
            }
        }
    },
    computed: {
    }
};
</script>
